declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function gtag(groups: string, sendTo: string): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push([groups, sendTo]);
}